import React, {useState} from 'react';
import Header from './Header.js';
import Disclaimers from './Disclaimers.js';

import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
        padding: 20,
        paddingTop:100,
        margin: 'auto',
      maxWidth: 800,
    },
    formCard: {
      padding: theme.spacing(2),
      textAlign: 'left',
      color: theme.palette.text.secondary,
        //margin: theme.spacing(2),
        alignItems: 'center',
    },
    card: {
        //padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
          //margin: theme.spacing(2),
          alignItems: 'center',
      }, 
      button: {
           padding: theme.spacing(2),
        margin: theme.spacing(2),
          alignItems: 'center',
          width: 150,
      },
      cardContent: {
          paddingTop: theme.spacing(1),
          paddintBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
      },
      cardAction: {
        justifyContent: 'left',  
         paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
      cardActionButton: {
        justifyContent: 'center',  
         paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
      media: {
          width: 100,
          //marginBottom: theme.spacing(4),
      },
      textField: {
      },
  }));

export default function ContactUs (props) {
    const classes = useStyles();
    const [userName, setUserName] = useState("");
    const [message, setMessage] = useState("");

    function handleFormSubmit(event) {
        event.preventDefault();
        console.log("Sending Message");
        const emailData = `mailto:fantesmdpsych@gmail.com?subject=Psych App Question&body=From User: ${userName}%0D%0AMessage: ${message}`
        window.open(emailData);
    }

    function handleUserNameChange (event) {
        setUserName(event.target.value);
    }

    function handleMessageChange (event) {
        setMessage(event.target.value);
    }

    function handleKeyPress(event) {
        if (event.key==="Enter") {
          event.preventDefault();
        }
      }

    return <>
            <div className={classes.root}>
                <Header title="Contact Us" subTitle="We appreciate your feedback and thoughts*"/>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Card className={classes.formCard}>
                            <form onSubmit={handleFormSubmit}>
                                <CardActions className={classes.cardAction}>
                                     <TextField id="userName" fullWidth className={classes.textField} label="Sender's Name" value={userName} onChange={handleUserNameChange} onKeyPress={handleKeyPress}/>                                   
                                </CardActions>
                                <CardActions className={classes.cardAction}>
                                    <TextField id="message" fullWidth multiline variant="outlined" rows={4} className={classes.textField} label="Message" value={message} onChange={handleMessageChange} />
                                </CardActions>
                                <CardActions className={classes.cardActionButton}>
                                    <Button className={classes.button} size="medium" id="submit" type="submit" name="submit" variant="contained" color="primary">Send</Button>
                                </CardActions>
                             </form>
                            
                            <CardContent className={classes.cardContent}>
                                <Typography className={classes.text} color="inherit">*Please only message for feedback or questions regarding Psych Apps. Clinical/medication/diagnostic questions will not be answered.</Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Disclaimers/>
            </div>
        </>;
}

/*                             <Typography className={classes.text} color="inherit" variant="subtitle2"> Do NOT send clinical questions (such as personal diagnostic and treatment questions, including medicaitons). Questions regarding medical treatment will NOT be answered. Please direct these to your respective medical and/or mental health providers.
                            <br /><br />
                            If you are a Dr. Fantes clinical patient, please do NOT contact Dr. Fantes through this site for clinical questions as this website's inbox is not secured. Please use the Fenway Health Portal to send him secured emails as usual instead--or call Fenway Health directly.</Typography> */